/**
 * Debug toggle:
 *   - `?debug=true|false` in the URL writes to localStorage (persists across navigation/reload)
 *   - Otherwise, falls back to the REACT_APP_DEBUG env var
 *
 * Evaluated once at module load — the URL is read at app startup, and the result
 * is cached for the rest of the session. Visit `?debug=true` once and the setting
 * sticks until the user visits `?debug=false`.
 */
const STORAGE_KEY = "focusDebug";

const urlDebug = new URLSearchParams(window.location.search).get("debug");
if (urlDebug === "true" || urlDebug === "false") {
  localStorage.setItem(STORAGE_KEY, urlDebug);
}
const storedDebug = localStorage.getItem(STORAGE_KEY);

export const DEBUG_ENABLED =
  storedDebug === "true" ||
  (storedDebug !== "false" && process.env.REACT_APP_DEBUG === "true");
